export default "__VITE_ASSET__BKpNOZ3N__"